import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Login from "./components/Login";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Licenses from "./pages/Licenses";
import Sessions from "./pages/Sessions";
import Logs from "./pages/Logs";
import DownloadPage from "./pages/DownloadPage";
import UserPanel from "./pages/UserPanel";

export default function App() {
  const [adminKey, setAdminKey] = useState(localStorage.getItem("admin_key") || "");

  const handleLogin = (key) => setAdminKey(key);
  const handleLogout = () => setAdminKey("");

  return (
    <BrowserRouter>
      <div style={{ background: "linear-gradient(135deg,#0f0f1a 0%,#1a1a2e 50%,#16213e 100%)", minHeight: "100vh" }}>
        <Toaster position="top-right" toastOptions={{ style: { background: "#1e2130", color: "#fff", border: "1px solid rgba(255,255,255,0.1)" } }} />
        <Routes>
          {/* User Panel — public */}
          <Route path="/" element={<UserPanel />} />

          {/* Admin Panel — protected */}
          <Route path="/seskab-teddy/*" element={
            !adminKey ? <Login onLogin={handleLogin} /> : (
              <>
                <Sidebar onLogout={handleLogout} />
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/licenses" element={<Licenses />} />
                  <Route path="/sessions" element={<Sessions />} />
                  <Route path="/logs" element={<Logs />} />
                  <Route path="/download" element={<DownloadPage />} />
                  <Route path="*" element={<Navigate to="/seskab-teddy" />} />
                </Routes>
              </>
            )
          } />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
